import React from 'react';
import { Grid } from 'semantic-ui-react';
import FileUploadButton from '../../fileUploadButton';

const ShopImages = ({ obj, onChange }) => {
  const headerDesk = obj.headerDesk ? obj.headerDesk : null;
  const headerMob = obj.headerMob ? obj.headerMob : null;
  const importantDesk = obj.importantDesk ? obj.importantDesk : null;
  const importantMob = obj.importantMob ? obj.importantMob : null;
  const logo1Desk = obj.logo1Desk ? obj.logo1Desk : null;
  const logo1Mob = obj.logo1Mob ? obj.logo1Mob : null;
  const logo2Desk = obj.logo2Desk ? obj.logo2Desk : null;
  const logo2Mob = obj.logo2Mob ? obj.logo2Mob : null;
  const imgDesk = obj.imgDesk ? obj.imgDesk : null;
  const imgMob = obj.imgMob ? obj.imgMob : null;

  return (
    <div>
      <Grid columns={4}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="headerDesk"
              label="Header (desktop)"
              image={headerDesk}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="headerMob"
              label="Header (mobile)"
              image={headerMob}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="importantDesk"
              label="Important (desktop)"
              image={importantDesk}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="importantMob"
              label="Important (mobile)"
              image={importantMob}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={4}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="logo2Desk"
              label="Logo blanc Desktop"
              image={logo2Desk}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="logo2Mob"
              label="Logo blanc Mobile"
              image={logo2Mob}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="logo1Desk"
              label="Logo noir Desktop"
              image={logo1Desk}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="logo1Mob"
              label="Logo noir Mobile"
              image={logo1Mob}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid columns={4}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton
              id="imgDesk"
              label="Image secondaire Desktop"
              image={imgDesk}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton
              id="imgMob"
              label="Image secondaire Mobile"
              image={imgMob}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default ShopImages;



// WEBPACK FOOTER //
// ./src/components/form/shop/images.js